export default __webpack_public_path__ + "static/media/pet-cin-ufpe.ea2064fd.svg";